import page from 'page'

export function setupXeroConnectRoutes (baseRoute) {
  page(`${baseRoute}`, async function () {
    console.log(`${baseRoute}`)

    const appAccountId = localStorage.getItem('appAccountId')
    localStorage.setItem('newXeroConnection', 'true')

    location.href = `/app/a/${appAccountId}/manage-xero`
  })
}
